// extracted by mini-css-extract-plugin
module.exports = {"PrintedManual":"PrintedManual_PrintedManual__foxqV"};